import { useState, useEffect } from "react";

import API from "utils/api";
import { useUser } from "utils/hooks";
import { filtersToQueryParams } from "utils/misc";

export default function useFollowing(userId, filters = {}) {
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchFollowing() {
      setLoading(true);
      const { response, data } = await API.fetchFollowing(userId, filtersToQueryParams(filters));

      if (response.ok) {
        setResult(data);
        setLoading(false);
      }
    }

    if (userId) {
      fetchFollowing();
    }
  }, [userId, Object.values(filters).join("__")]);

  return {
    loading,
    results: result?.results ?? [],
    count: result?.count ?? 0,
    limit: result?.limit ?? 0,
    page: result?.page ?? 0,
  };
}

